import LoyaltyBurnPriceDisplay from 'loyalty/components/LoyaltyBurnPriceDisplay'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import type { PackageSelectionPayment } from './packageSelectionBurnQuote'

interface Props {
  price: number
  memberPrice: number
  payment: { regular: PackageSelectionPayment, member: PackageSelectionPayment }
  size?: 'S' | 'M' | 'L'
  offerConfig?: App.OfferLuxPlusConfig
}

function PackageSelectionBurnPrice({ price, memberPrice, payment, size = 'M', offerConfig }: Props) {
  if (!payment.regular.points && !payment.member.points) {
    return <LuxPlusPriceStack price={payment.regular.cash} memberPrice={payment.member.cash} size={size} saleUnit="total" offerConfig={offerConfig} />
  }
  return <LoyaltyBurnPriceDisplay
    totalPrice={price}
    memberPrice={memberPrice}
    allocatedPayment={payment}
    size={size}
    saleUnit="total"
    offerConfig={offerConfig}
  />
}

export default PackageSelectionBurnPrice
